import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuthContext } from '@/contexts/AuthContext';

/**
 * Controla o tour guiado de primeiro acesso.
 *
 * O tour dispara só quando:
 *  - o usuário ainda não concluiu o tutorial (tutorial_completed_at === null), e
 *  - está na home (`/`) — os passos apontam para elementos do Dashboard.
 *
 * Se o usuário cair em outra rota, o tour não dispara; ao voltar para `/`, dispara.
 */
export function useTour() {
  const { user, completeTutorial } = useAuthContext();
  const location = useLocation();
  const [shouldStart, setShouldStart] = useState(false);

  useEffect(() => {
    if (user && user.tutorial_completed_at === null && location.pathname === '/') {
      // Pequeno delay para o layout renderizar antes do spotlight
      const timer = setTimeout(() => setShouldStart(true), 800);
      return () => clearTimeout(timer);
    }
  }, [user, location.pathname]);

  const finishTour = async () => {
    setShouldStart(false);
    try {
      await completeTutorial();
    } catch (err) {
      console.error('Falha ao marcar tutorial como concluído', err);
      // Não bloquear — o tour já encerrou localmente
    }
  };

  const skipTour = () => {
    void finishTour();
  };

  return { shouldStart, finishTour, skipTour };
}
